/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useForm } from 'react-hook-form'

import { zodResolver } from '@hookform/resolvers/zod'
import { useDocumentInputs } from '@hooks/useDocumentInputs'
import { sendEventGA } from '@services/analytics'

import { type DNIFormData, DNISchema, initialForm } from './DNISchema'

interface Params {
  onSubmitDNIForm: (data: DNIFormData) => Promise<void>
}

export const useDNIForm = ({ onSubmitDNIForm }: Params) => {
  const {
    control,
    formState: { isSubmitting, errors },
    setError,
    clearErrors,
    setValue,
    handleSubmit,
    watch
  } = useForm<DNIFormData>({
    mode: 'onSubmit',
    defaultValues: initialForm,
    resolver: zodResolver(DNISchema)
  })
  const values = watch()
  const { documentTypes, onChangeDocumentNumber } = useDocumentInputs({
    clearErrors,
    documentType: values.documentType,
    setValue,
    watch
  })
  const onSubmit = async (data: DNIFormData) => {
    if (data.documentNumber && data.documentType) {
      sendEventGA('validacion_documento', {
        hash_doc: data.documentNumber,
        type_doc: documentTypes?.find(d => d.id === data.documentType)?.name
      })
    }

    try {
      await onSubmitDNIForm(data)
    } catch (error) {
      setError('documentNumber', { message: 'Número de documento inválido' })
    }
  }

  return {
    control,
    documentTypes,
    errors,
    isSubmitting,
    onSubmit,
    values,

    handleSubmit,
    onChangeDocumentNumber
  }
}
